export const CancellationWaiveOffRequestStatuses = {
    NEW: 1,
    APPROVED: 2,
    DENIED: 3,
}